import { render, staticRenderFns } from "./CandidateTestResultQuestion.vue?vue&type=template&id=2ee7eb0c&scoped=true&"
import script from "./CandidateTestResultQuestion.vue?vue&type=script&lang=js&"
export * from "./CandidateTestResultQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CandidateTestResultQuestion.vue?vue&type=style&index=0&id=2ee7eb0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7eb0c",
  null
  
)

/* custom blocks */
import block0 from "./CandidateTestResultQuestion.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateTestResultQuestion.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
